import { toast } from 'react-toastify';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { Handlers } from '../../../types/actions/types';
import { fetchOperatingInflowTableDataService, exportOperatingInflowReconService } from './reconciliationService';
import { EXT_MIME } from '../../../common/DocumentViewer/constants';

export async function downloadOperatingInflowReconExport(
    payload: { orgId: string; gstType: string; startDate?: string; endDate?: string },
    handlers?: { onSuccess?: () => void; onError?: () => void },
) {
    try {
        const response = await exportOperatingInflowReconService(payload);
        const blob = new Blob([response.data], { type: EXT_MIME.xlsx });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Reconciliation_${payload.orgId}_${payload.startDate ?? 'start'}_${payload.endDate ?? 'end'}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        handlers?.onSuccess?.();
    } catch (err: unknown) {
        const status = (err as { response?: { status?: number } })?.response?.status;
        if (status === 504 || status === 408) {
            toast.error('Export timed out. Please narrow the date range and try again.');
        } else {
            toast.error('Export failed. Please try again.');
        }
        console.error('Error in downloading recon export', err);
        handlers?.onError?.();
    }
}

export async function fetchOperatingInflowReconData(payload, handlers: Handlers) {
    try {
        const response = await fetchOperatingInflowTableDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return;
            case JAVA_API_STATUS.ERROR:
                handlers?.onError?.();
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}
